// Adapters: Singapore packages → listing cards + detail-template data (reuses the shared createAdapters from vietnamToursData).
import { createAdapters } from './vietnamToursData';
import { packages, cityImages } from '../singaporePackages';
import { bestOfSingaporeThailandProduct } from './bestOfSingaporeThailandData';
import { romanticSingaporeNightSafariSentosaProduct } from './romanticSingaporeNightSafariSentosaData';
import { singaporeShortBreakNightSafariProduct } from './singaporeShortBreakNightSafariData';
import { singaporeFamilyUniversalStudiosProduct } from './singaporeFamilyUniversalStudiosData';
import { singaporeHighlightsSentosaGardensProduct } from './singaporeHighlightsSentosaGardensData';
import { singaporeWildlifeSkylineEscapeProduct } from './singaporeWildlifeSkylineEscapeData';
import { singaporeCouplesAdventureCoveProduct } from './singaporeCouplesAdventureCoveData';
import { singaporeCouplesSpecialJewelProduct } from './singaporeCouplesSpecialJewelData';
import { singaporeFamilySafariCityLightsProduct } from './singaporeFamilySafariCityLightsData';
import { singaporeWildTrailsIslandDaysProduct } from './singaporeWildTrailsIslandDaysData';
import { singaporeGentingDreamCruiseProduct } from './singaporeGentingDreamCruiseData';
import { singaporeHoneymoonGentingCruiseProduct } from './singaporeHoneymoonGentingCruiseData';
import { singaporePenangRoyalCaribbeanProduct } from './singaporePenangRoyalCaribbeanData';
import { disneyAdventureCruiseSingaporeProduct } from './disneyAdventureCruiseSingaporeData';
import { singaporeMalaysiaHoneymoonProduct } from './singaporeMalaysiaHoneymoonData';
import { singaporeMalaysiaSentosaGentingProduct } from './singaporeMalaysiaSentosaGentingData';

import { singaporeBaliHoneymoonProduct } from './singaporeBaliHoneymoonData';
import { singaporeMalaysiaBaliHoneymoonProduct } from './singaporeMalaysiaBaliHoneymoonData';
import { baliSingaporeFamilyHolidayProduct } from './baliSingaporeFamilyHolidayData';
import { grandSingaporeMalaysiaBaliProduct } from './grandSingaporeMalaysiaBaliData';
import { bestOfThailandSingaporeMalaysiaBaliProduct } from './bestOfThailandSingaporeMalaysiaBaliData';

const { toProduct, build } = createAdapters({
  cityImages, base: '/asia', ctaHref: '/l/singapore/enquiry/passengers/', cruiseCity: '—',
  expert: { name: 'Nisha Rao', image: '/experts/riya.webp', role: 'Singapore expert at Hi Tours', createdBy: 'Trip created by', more: 'Read more', less: 'Read less' },
  crumbs: [{ label: 'Destinations', href: '/#destinations' }, { label: 'Asia', href: '/asia' }, { label: 'Singapore', href: '/asia/singapore' }]
});

export const singaporeProducts = [
  bestOfSingaporeThailandProduct,
  romanticSingaporeNightSafariSentosaProduct,
  singaporeShortBreakNightSafariProduct,
  singaporeFamilyUniversalStudiosProduct,
  singaporeHighlightsSentosaGardensProduct,
  singaporeWildlifeSkylineEscapeProduct,
  singaporeCouplesAdventureCoveProduct,
  singaporeCouplesSpecialJewelProduct,
  singaporeFamilySafariCityLightsProduct,
  singaporeWildTrailsIslandDaysProduct,
  singaporeGentingDreamCruiseProduct,
  singaporeHoneymoonGentingCruiseProduct,
  singaporePenangRoyalCaribbeanProduct,
  disneyAdventureCruiseSingaporeProduct,
  singaporeMalaysiaHoneymoonProduct,
  singaporeMalaysiaSentosaGentingProduct,
  singaporeBaliHoneymoonProduct,
  singaporeMalaysiaBaliHoneymoonProduct,
  baliSingaporeFamilyHolidayProduct,
  grandSingaporeMalaysiaBaliProduct,
  bestOfThailandSingaporeMalaysiaBaliProduct
];
export const singaporeTours = [];
export const singaporeBySlug = {};
